class UserInfo {
    displayName: string;
    msGraphObjectId: string;
    accountEnabled: boolean;
}

export { UserInfo }
